export default __webpack_public_path__ + "static/media/Cecilia-Treasurer.b29bd25f.jpg";